<template>
  <main>
    <app-loading :loading="loading">
      <MarketPaymentModal
          v-if="selectedBuyingProduct"
          :product-id="selectedBuyingProduct"
          @close="selectedBuyingProduct = null"
      />
      <router-view></router-view>
    </app-loading>
  </main>
</template>

<script>
import MarketPaymentModal from "@/components/market/payment/MarketPaymentModal";

export default {
  components: {
    MarketPaymentModal
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    selectedBuyingProduct: {
      get: function () {
        return this.$store.state.market.selectedBuyingProduct;
      },
      set: function (val) {
        this.$store.commit('market/buyProduct', null);
      }
    }
  },
  async created() {
    await this.$store.dispatch('market/loadAll');
    this.loading = false;
  }
}
</script>